BaseHandler = App.loadClass "core::reports/BaseHandler"
BaseOutput = App.loadClass "core::reports/BaseOutput"
ChartOutput = App.loadClass "core::reports/ChartOutput"

class exports.ReportsNEconomicsSubHandler extends BaseHandler
    init: () ->
        @hasPrint       = false
        @parent.dialog.find('.print-btn').hide()
        @sourceUrl      = 'backend/grower/reports/n-economics/output/detail'
        @layoutUrl      = 'backend/grower/reports/n-economics/chart'
        @filterUrl      = 'backend/grower/reports/n-economics/filters'
        @layoutSelector = "#reports_n_economics_tab"

        $('.sidebar_content').find('.view-field-group-button-container').removeClass('hide')
        @parent.dialog.find('.neconomics-label').removeClass('hide')
        @parent.dialog.find('.neconomics-label').clickover
            html: true
            container: '#bs2-container'

        @initFilters()

        @borderWidth = 2
        @hoverBorderWidth = 3

    afterLoadLayout: () ->
        super()

    initFilters: () ->
        @disableAllFilterGroups()

        @parent.filters.importGroup
            name: 'N Economics Report Filters'
            display_name: 'Report Filters'
            filters: [
                name: 'neconomics_years'
                display_name: 'Year'
                control_type: 'single_dropdown'
                deletable: false
                auto_select_first: true
            ,
                name: 'neconomics_crops'
                display_name: 'Crop'
                control_type: 'single_dropdown'
                deletable: false
                auto_select_only_value: true
            ,
                name: 'neconomics_previous_crops'
                display_name: 'Previous Crop'
                control_type: 'single_dropdown'
            ,
                name: 'neconomics_distances'
                display_name: 'Distance'
                values: [
                    { key: '0-50', value: '0 - 50 miles' }
                    { key: '50-75', value: '50 - 75 miles' }
                    { key: '75-100', value: '75 - 100 miles' }
                    { key: '100-', value: '>100 miles' }
                ]
            ,
                name: 'neconomics_operation_sizes'
                display_name: 'Operation Size'
                values: [
                    { key: '0-250', value: '0 - 250 acres' }
                    { key: '250-2500', value: '250 - 2500 acres' }
                    { key: '2500-5000', value: '2500 - 5000 acres' }
                    { key: '5000-', value: '5000+ acres' }
                ]
            ,
                name: 'neconomics_partners'
                display_name: 'Partner'
                control_type: 'single_dropdown'
            ,
                name: 'neconomics_field_groups'
                display_name: 'Field Group'
                control_type: 'single_dropdown'
            ,
                name: 'irrigation_type'
                display_name: 'Irrigation Type'
                control_type: 'option'
                deletable: true
                values: [
                    { key: 'irrigated', value: 'Irrigated' }
                    { key: 'dryland', value: 'Dryland' }
                ]
            ,
                name: 'neconomics_field'
                display_name: 'Field'
                control_type: 'single_dropdown'
            ]

        @parent.filters.importGroup
            name: 'N Economics Filters'
            filters: [
                name: 'neconomics_practices'
                display_name: 'Practices'
                control_type: 'single_dropdown'
            ,
                name: 'neconomics_tillage_systems'
                display_name: 'Tillage System'
                control_type: 'single_dropdown'
            ,
                name: 'neconomics_primary_nitrogen_sources'
                display_name: 'Primary N Source'
                control_type: 'single_dropdown'
            ,
                name: 'neconomics_nitrogen_rates'
                display_name: 'Nitrogen Rate'
                control_type: 'single_dropdown'
            ]

        @setDefaultsAndRun(0, 0, 0, {}, 'up', false)

    destroy: () ->
        @parent.filters.removeGroup 'N Economics Report Filters'
        @parent.filters.removeGroup 'N Economics Filters'
        @parent.filters.enableGroup "Report Filters"

        @parent.dialog.find('.excel-btn').addClass('hidden')
        @parent.dialog.find('.info-popover').addClass('hide')
        $('.sidebar_content').find('.view-field-group-button-container').addClass('hide')

        super()

    getDataDetail: () =>
        return $.get('backend/grower/reports/n-economics/output/detail', { query: @filters })

    beforeApply: () ->
        filters = @parent.filters.jsonize()
        firstLoad = not @currentOutput?

        unless @currentOutput?
            @getDataDetail()

    finishRunning: () ->
        if $.contains(document, @parent.msg[0]) and @parent.msg.length isnt 0
            @parent.msg.message_writer 'error', 'Insufficient data have been entered in your area to draw statistically significant conclusions at this time.  Please continue recruiting growers to participate. We look forward to unlocking practical production insights as soon as possible.'
